var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-block"},[_vm._t("alert"),(_vm.description)?_c('div',{staticClass:"info-block__content"},[_c('div',{ref:"limit",staticClass:"info-block__limit",class:_vm.visibleStyle},[_vm._t("text")],2),_c('div',{staticClass:"info-block__btn"},[(_vm.height > _vm.limit)?_c('div',{staticClass:"info-block__btn-text",on:{"click":_vm.showMore}},[_c('div',{domProps:{"textContent":_vm._s(
            _vm.show
              ? _vm.$tr('buttons.collapseDescription')
              : _vm.$tr('buttons.expandDescription')
          )}})]):_vm._e()])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }